import { AuthContext } from 'app/AuthProvider';
import React from 'react';

const useAuth = () => React.useContext(AuthContext);

export default useAuth;
